import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import {
  setPerformanceActivePanel,
  showEpicRelatedTasks,
  showTeamRelatedTasks,
} from '../../../../../store/strategy-store/strategy-store.actions';
import { SideSectionEpics } from '../../components/side-section-epics/side-section-epics';
import { SideSectionTeams } from '../../components/side-section-teams/side-section-teams';
import { ThroughputMode } from '../../initiative-performance.type';

export const SideSection = () => {
  const throughputMode = useThroughputTabStore((state) => state.mode);

  const team = useThroughputTabStore((state) => state.selectedTeam);
  const epic = useThroughputTabStore((state) => state.selectedEpic);
  const selectedDate = useThroughputTabStore((state) => state.selectedDate);

  const onClose = () => {
    setPerformanceActivePanel(null);
  };

  const onClickEpicRelatedTasks = () => {
    if (!selectedDate) {
      return;
    }

    showEpicRelatedTasks({ epic: epic?.id, date: selectedDate });
  };

  const onClickTeamRelatedTasks = () => {
    if (!selectedDate) {
      return;
    }

    showTeamRelatedTasks({ team: team?.id, date: selectedDate });
  };

  switch (throughputMode) {
    case ThroughputMode.ContributingEpics:
      return (
        <SideSectionEpics
          epic={epic}
          selectedDate={selectedDate}
          onClose={onClose}
          onClickRelatedTasks={onClickEpicRelatedTasks}
        />
      );
    case ThroughputMode.ContributingTeams:
      return (
        <SideSectionTeams
          team={team}
          selectedDate={selectedDate}
          onClose={onClose}
          onClickRelatedTasks={onClickTeamRelatedTasks}
        />
      );
    default:
      return null;
  }
};
